<template>
    <div class="kuli-page">
        <div class="kuli-search-card">
            <label class="kuli-search-label">Cari Kuli</label>
            <input
                v-model="filter.search"
                class="kuli-search-input"
                type="search"
                placeholder="Masukkan Nama Kuli"
                @keyup.enter="getKuli"
            >
            <button class="kuli-search-button" type="button" @click="getKuli">CARI</button>
        </div>

        <div class="kuli-table-card">
            <div class="kuli-table-header">
                <h3>Daftar Nama Kuli</h3>
                <button class="kuli-add-button" type="button" @click="openAddModal">+ Tambah Kuli</button>
            </div>

            <vue-universal-table
                api_url="/api/settings/get-kuli"
                :filter="filter"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                :buttons="vue_universal_table.buttons"
                :process_data="vue_universal_table.process_data"
                :infinite_scroll="true"
                :pagination="false"
                sort_order="DESC"
                sort_by="created_at"
                class="kuli-universal-table"
                @onEditKuli="openEditModal"
                @onDeleteKuli="deleteKuli"
            />
        </div>

        <cu-kuli
            v-if="modal.show"
            :data="modal.data"
            @closeModal="closeModal"
            @refreshData="getKuli"
        />
    </div>
</template>

<script>
import CuKuli from './children/CUKuli.vue'

export default {
    metaInfo: {
        title: 'Kuli'
    },
    components: {
        CuKuli
    },
    data() {
        return {
            filter: {
                search: null
            },
            vue_universal_table: {
                update: 0,
                fields: [
                    { title: 'Nama', variable: 'name' },
                    { title: 'Tanggal Dibuat', variable: 'created_at', date_format: 'DD/MM/YYYY' },
                    {
                        title: 'Status',
                        variable: 'status',
                        class: 'kuli-status-cell',
                        style_condition: {
                            ACTIVE: 'color: #117A20; font-weight: 700;',
                            INACTIVE: 'color: #FF3434; font-weight: 700;'
                        }
                    }
                ],
                buttons: [
                    { title: 'editKuli', class: 'fas fa-pen kuli-table-action kuli-table-action-edit' },
                    { title: 'deleteKuli', variable: 'id', class: 'fas fa-trash kuli-table-action kuli-table-action-delete' }
                ],
                process_data: `
                    for (var i in data) {
                        data[i].name = data[i].name ? data[i].name : '-'
                        data[i].status = (data[i].status === 1 || data[i].status === '1' || data[i].status === true || data[i].status === 'ACTIVE') ? 'ACTIVE' : 'INACTIVE'
                    }
                `
            },
            modal: {
                show: false,
                data: null
            }
        }
    },
    methods: {
        getKuli() {
            this.vue_universal_table.update++
        },
        openAddModal() {
            this.modal.data = null
            this.modal.show = true
        },
        openEditModal(data) {
            this.modal.data = typeof data === 'string' ? JSON.parse(data) : JSON.parse(JSON.stringify(data))
            this.modal.show = true
        },
        closeModal() {
            this.modal.show = false
            this.modal.data = null
        },
        deleteKuli(id) {
            this.$swal.fire({
                title: 'Apakah Anda yakin?',
                html: 'data yang telah dihapus tidak dapat<br>dikembalikan lagi',
                icon: 'warning',
                showCancelButton: true,
                buttonsStyling: false,
                reverseButtons: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                customClass: {
                    popup: 'kuli-delete-popup',
                    title: 'kuli-delete-title',
                    htmlContainer: 'kuli-delete-text',
                    actions: 'kuli-delete-actions',
                    confirmButton: 'kuli-delete-confirm',
                    cancelButton: 'kuli-delete-cancel',
                    icon: 'kuli-delete-icon'
                }
            }).then((result) => {
                if (result.value) {
                    this.$http.delete(`/api/settings/delete-kuli/${id}`)
                        .then(() => {
                            this.$swal.fire({
                                title: 'Berhasil Menghapus Kuli',
                                icon: 'success',
                                type: 'success',
                                confirmButtonColor: '#1B698E',
                                customClass: {
                                    popup: 'kuli-success-popup',
                                    title: 'kuli-success-title',
                                    confirmButton: 'kuli-success-confirm',
                                    icon: 'kuli-success-icon'
                                }
                            })
                            this.getKuli()
                        })
                        .catch((error) => {
                            this.$swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                type: 'error',
                                text: error.response && error.response.data ? error.response.data.message : 'Gagal menghapus kuli'
                            })
                        })
                }
            })
        }
    }
}
</script>

<style scoped>
.kuli-page {
    color: #343434;
    font-family: Poppins, sans-serif;
}

.kuli-search-card,
.kuli-table-card {
    background: #FFFFFF;
    border: 1px solid #EFF3F7;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000F;
}

.kuli-search-card {
    align-items: center;
    display: grid;
    gap: 24px;
    grid-template-columns: 104px 1fr 137px;
    margin-bottom: 16px;
    padding: 24px 25px;
}

.kuli-search-label {
    font: normal normal normal 16px/25px Poppins;
    margin: 0;
}

.kuli-search-input {
    border: 1px solid #D8D8D8;
    border-radius: 6px;
    color: #343434;
    font: normal normal normal 16px/25px Poppins;
    height: 38px;
    padding: 6px 10px;
}

.kuli-search-input::placeholder {
    color: #B6B6B6;
}

.kuli-search-button {
    background: #1B698E;
    border: 0;
    border-radius: 6px;
    color: #FFFFFF;
    font: normal normal 600 14px/21px Poppins;
    height: 38px;
}

.kuli-table-card {
    overflow: hidden;
}

.kuli-table-header {
    align-items: center;
    border-bottom: 1px solid #F0F0F0;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    min-height: 86px;
    padding: 0 25px;
}

.kuli-table-header h3 {
    color: #343434;
    font: normal normal normal 16px/25px Poppins;
    grid-column: 2;
    margin: 0;
    text-align: center;
}

.kuli-add-button {
    background: #CEEDF8;
    border: 0;
    border-radius: 6px;
    color: #343434;
    font: normal normal normal 12px/18px Poppins;
    grid-column: 3;
    height: 36px;
    justify-self: end;
    min-width: 124px;
    padding: 0 16px;
}

.kuli-universal-table {
    padding: 0 25px 10px;
}

.kuli-page /deep/ .kuli-universal-table .table {
    margin: 0;
}

.kuli-page /deep/ .kuli-universal-table .table-striped tbody tr:nth-of-type(odd) {
    background-color: #FFFFFF;
}

.kuli-page /deep/ .kuli-universal-table th,
.kuli-page /deep/ .kuli-universal-table td {
    border-bottom: 1px solid #F3F3F3;
    border-top: 0;
    color: #343434;
    font: normal normal normal 12px/18px Poppins;
    height: 54px;
    padding: 0 5px;
    vertical-align: middle;
}

.kuli-page /deep/ .kuli-universal-table th:nth-child(3),
.kuli-page /deep/ .kuli-universal-table td:nth-child(3),
.kuli-page /deep/ .kuli-universal-table th:nth-child(4),
.kuli-page /deep/ .kuli-universal-table td:nth-child(4),
.kuli-page /deep/ .kuli-universal-table th:nth-child(5),
.kuli-page /deep/ .kuli-universal-table td:nth-child(5) {
    text-align: center;
}

.kuli-page /deep/ .kuli-status-cell {
    font-weight: 700;
}

.kuli-page /deep/ .kuli-universal-table th[colspan="2"] i {
    display: none;
}

.kuli-page /deep/ .kuli-universal-table th[colspan="2"]::after {
    content: 'Aksi';
}

.kuli-page /deep/ .kuli-table-action {
    align-items: center;
    background: #FFFFFF;
    border-radius: 6px;
    display: inline-flex;
    font-size: 0;
    height: 30px;
    justify-content: center;
    padding: 0;
    width: 30px;
}

.kuli-page /deep/ .kuli-table-action i {
    font-size: 14px;
    margin: 0;
}

.kuli-page /deep/ .kuli-table-action-edit {
    border: 1px solid #1CAAED;
    color: #1CAAED;
}

.kuli-page /deep/ .kuli-table-action-delete {
    border: 1px solid #FF6B6B;
    color: #FF6B6B;
}

@media (max-width: 768px) {
    .kuli-search-card {
        grid-template-columns: 1fr;
    }

    .kuli-search-button {
        width: 100%;
    }

    .kuli-table-header {
        gap: 16px;
        grid-template-columns: 1fr;
        padding: 20px;
    }

    .kuli-table-header h3,
    .kuli-add-button {
        grid-column: 1;
        justify-self: stretch;
    }
}
</style>

<style>
.kuli-delete-popup.swal2-popup {
    border-radius: 6px;
    padding: 34px 48px 32px;
    width: 431px;
}

.kuli-delete-icon.swal2-icon.swal2-warning {
    border-color: #F8C04D;
    color: #F8C04D;
    margin: 0 auto 14px;
}

.kuli-delete-title.swal2-title {
    color: #343434;
    font: normal normal 700 22px/33px Poppins;
    margin: 0;
    padding: 0;
}

.kuli-delete-text.swal2-html-container {
    color: #343434;
    font: normal normal normal 14px/21px Poppins;
    margin: 8px 0 0;
}

.kuli-delete-actions.swal2-actions {
    gap: 32px;
    margin: 26px 0 0;
}

.kuli-delete-confirm,
.kuli-delete-cancel,
.kuli-delete-confirm.swal2-styled,
.kuli-delete-cancel.swal2-styled {
    border: 0;
    border-radius: 4px;
    box-shadow: none;
    color: #FFFFFF;
    font: normal normal normal 16px/25px Poppins;
    height: 42px;
    margin: 0;
    min-width: 126px;
    padding: 0 24px;
}

.kuli-delete-confirm,
.kuli-delete-confirm.swal2-styled {
    background: #F14E4E;
}

.kuli-delete-cancel,
.kuli-delete-cancel.swal2-styled {
    background: #1B698E;
}

.kuli-success-popup.swal2-popup {
    border-radius: 6px;
    padding: 46px 48px 50px;
    width: 524px;
}

.kuli-success-icon.swal2-icon.swal2-success {
    margin: 0 auto 24px;
}

.kuli-success-title.swal2-title {
    color: #343434;
    font: normal normal 700 24px/36px Poppins;
    margin: 0;
    padding: 0;
}

.kuli-success-confirm.swal2-styled {
    background: #1B698E !important;
    border: 0;
    border-radius: 6px;
    box-shadow: none;
    color: #FFFFFF;
    font: normal normal normal 18px/27px Poppins;
    height: 46px;
    margin-top: 32px;
    min-width: 132px;
    padding: 0 32px;
}
</style>
